{
  "name": "@w3booster/client",
  "version": "2.1.1",
  "private": true,
  "description": "W3Booster Client",
  "scripts": {
    "prestart": "pnpm --filter @w3booster/datamodel build",
    "prestart:dev": "pnpm --filter @w3booster/datamodel build",
    "prestart:prod": "pnpm --filter @w3booster/datamodel build",
    "pretest": "pnpm --filter @w3booster/datamodel build",
    "build": "pnpm run build:prod",
    "ng": "ng",
    "start": "ng serve --configuration=local --o --host 0.0.0.0 --ssl",
    "start:dev": "ng serve --configuration=development --o --host 0.0.0.0",
    "start:prod": "ng serve --configuration=production --o --host 0.0.0.0",
    "check:typography": "node scripts/check-content-typography.mjs",
    "inject:platform-urls": "node scripts/inject-platform-urls.mjs",
    "build:local": "pnpm run check:typography && ng build --configuration=local && pnpm run inject:platform-urls",
    "build:dev": "pnpm run check:typography && ng build --configuration=development && pnpm run inject:platform-urls",
    "build:prod": "pnpm run check:typography && ng build --configuration production && pnpm run inject:platform-urls && pnpm run check:production",
    "check:production": "xvfb-run -a node scripts/check-production-bundle.mjs",
    "test": "ng test --watch=false --browsers=ChromeHeadless && pnpm run test:desktop",
    "test:watch": "ng test",
    "test:desktop": "node --test scripts/patch-installed-launcher.test.mjs scripts/desktop-restart.test.mjs scripts/patch-integrity.test.mjs scripts/recorder-relay.test.mjs scripts/overlay-input.test.mjs scripts/desktop-diagnostics.test.mjs scripts/setting-hotkeys.test.mjs",
    "check:windows-session": "node scripts/check-windows-session-restart.mjs",
    "generate": "ng generate",
    "xprecommit": "lint-staged",
    "lint": "pnpm run check:typography && tslint --fix --config tslint.json --project tsconfig.json",
    "format:fix": "pretty-quick --staged",
    "install:browser": "node scripts/install-browser-dependencies.mjs"
  },
  "lint-staged": {
    "src/**/*.ts": [
      "pretty-quick --staged",
      "tslint --fix --config tslint.json --project tsconfig.json",
      "git add"
    ]
  },
  "browser": {
    "fs": false,
    "http": false,
    "os": false,
    "ffi": false,
    "net": false,
    "path": false,
    "crypto": false,
    "ref": false,
    "ref-struct": false,
    "child_process": false,
    "@electron/remote": false
  },
  "author": "Patrick Schäfer",
  "license": "Patrick Schäfer",
  "dependencies": {
    "@angular/animations": "^18.2.13",
    "@angular/common": "^18.2.13",
    "@angular/compiler": "^18.2.13",
    "@angular/core": "^18.2.13",
    "@angular/forms": "^18.2.13",
    "@angular/localize": "^18.2.13",
    "@angular/platform-browser": "^18.2.13",
    "@angular/platform-browser-dynamic": "^18.2.13",
    "@angular/router": "^18.2.13",
    "@ng-bootstrap/ng-bootstrap": "^17.0.1",
    "@ng-select/ng-select": "^13.9.1",
    "@nth-cloud/ng-toggle": "^11.0.0",
    "@w3booster/datamodel": "workspace:*",
    "@w3booster/platform-config": "workspace:*",
    "bootstrap": "^4.6.2",
    "deep-diff": "^1.0.2",
    "events": "^3.3.0",
    "jwt-decode": "^4.0.0",
    "marked": "18.0.11",
    "ngx-toastr": "^19.0.0",
    "parse": "^5.3.0",
    "reconnecting-websocket": "^4.4.0",
    "rxjs": "^6.5.4",
    "tslib": "^2.0.0",
    "ws": "^8.18.1",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.19",
    "@angular/cli": "^18.2.19",
    "@angular/compiler-cli": "^18.2.13",
    "@angular/language-service": "^18.2.13",
    "@electron/remote": "^2.0.1",
    "@types/electron": "^1.6.10",
    "@types/ffi": "^0.2.2",
    "@types/jasmine": "^5.1.9",
    "@types/node": "^12.12.29",
    "@types/parse": "^3.0.9",
    "@types/ref": "0.0.28",
    "@types/ref-struct": "0.0.29",
    "@types/ws": "^8.18.1",
    "cross-env": "^7.0.3",
    "electron": "^15.0.0",
    "jasmine-core": "^5.9.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "playwright": "1.62.1",
    "typescript": "5.5.4"
  }
}
